import { Component, Input } from "@angular/core";

import { LoginService } from "./login.service";

import { Fmt } from "../../fmt.service";
import { Auth } from "../../auth.service";

@Component({
  selector: "login",
  templateUrl: "./login.component.html",
  providers: [Fmt, LoginService, Auth]
})
export class LoginComponent {
  public user: User = <User>{};
  public errMsg: string = "";

  constructor(
    public _fmt: Fmt,
    public _auth: Auth,
    public _loginService: LoginService
  ) {
    if (this._auth.loggedIn()) {
      window.location.href = "/home";
    }
  }

  submitLogin() {
    this.errMsg="";
    this._loginService.Login(this.user).subscribe(
      result => {
        let res = result.json();
        localStorage.setItem("token", res["token"]);
        window.location.href = "/";
      },
      err => {
        if(err.status==401){
          this.errMsg="Emailまたはパスワードが違います";
        }
      }
    );
  }
}

export interface User {
  email: string;
  password: string;
}
